import { selectors } from '../Constants';
import DeckCase from '../components/DeckCase';
import PriceManager from '../components/PriceManager';
import ProductItem from '../components/ProductItem';

export default class FeaturedProducts {
  constructor(section) {
    this.section = section;
    this.deckCase = new DeckCase(this.section.el.querySelector('[data-cards]'));

    this.priceManager = new PriceManager(this.section.el);
    this.priceManager.updateAll();

    this.productItemEls = this.section.el.querySelectorAll(selectors.product.item.el);
    this.productItems = [];

    for (let i = 0; i < this.productItemEls.length; i += 1) {
      this.productItems.push(new ProductItem(this.productItemEls[i]));
    }
  }

  onSectionUnload() {
    this.deckCase.onSectionUnload();

    for (let i = 0; i < this.productItems.length; i += 1) {
      this.productItems[i].unload();
    }
  }
}
